let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("kDjU6")).then(() => parcelRequire('gjZmQ'));